// LiveStreamUser.js
import { connect } from 'react-redux';

import { LIVESTREAM_EXIT_ALERT } from '../RemoteConfigKeys.js';

import getUsername from '../selector/getUsername.js';
import getMeData from '../selector/getMeData.js';
import getUserData from '../selector/getUserData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getLivestreamEarning from '../selector/getLivestreamEarning.js';
import getIsPrivateShowUnlocked from '../selector/getIsPrivateShowUnlocked.js';
import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import fetchUser from '../action/fetchUser.js';
import sendFollowUser from '../action/sendFollowUser.js';
import leaveLiveStreams from '../action/leaveLiveStreams.js';
import fetchUserIsFollowing from '../action/fetchUserIsFollowing.js';
import addModal from '../action/addModal.js';
import toggleSubscribeOnlineStatus from '../action/toggleSubscribeOnlineStatus.js';

import LiveStreamUser from '../component/LiveStreamUser.jsx';

const mapStateToProps = (state, { streamId }) => {
  const meId = getMeData(state, 'id');
  const fundingId = getLiveStreamData(
    state,
    [streamId, 'privateShow'],
    'fundingId'
  );
  const isPrivateShowUnlocked = getIsPrivateShowUnlocked(
    state,
    streamId,
    fundingId,
    meId
  );
  const isPrivateStreamUnlocked = getOperationData(
    state,
    ['liveStream', 'paid', streamId],
    'isPrivateStreamUnlocked'
  );
  return {
    username: getUserData(state, streamId, 'username'),
    displayedUsername: getUsername(state, streamId, 'displayNameFirst'),
    earnings: getLivestreamEarning(state, streamId),
    isFollowing: getUserData(state, streamId, 'isFollowing'),
    isPrivateShowUnlocked,
    isPrivateStreamUnlocked,
    shouldShowExitAlertModal:
      getRemoteConfigData(state, LIVESTREAM_EXIT_ALERT) === 1,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUser: ({ userId }) => dispatch(fetchUser({ id: userId })),
    followUser: ({ userId }) => dispatch(sendFollowUser({ id: userId })),
    fetchUserIsFollowing: ({ userId }) =>
      dispatch(fetchUserIsFollowing({ userId })),
    leaveLiveStreams: () => dispatch(leaveLiveStreams()),
    addModal: ({ id }) => dispatch(addModal({ id })),
    toggleSubscribeOnlineStatus: ({
      userId,
      shouldSubscribe,
      isCritical,
      subscriptionReference,
    }) =>
      dispatch(
        toggleSubscribeOnlineStatus({
          userId,
          isCritical,
          shouldSubscribe,
          subscriptionReference,
        })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveStreamUser);
